import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
//#region types
import { TranslationKeys } from "translations";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import {
  PageLayouts,
  SimpleEntityTitle,
  useMountedState,
  BreadCrumb,
  useNavigationHistory,
  WizardContextProvider,
  FormValidity,
} from "components/common";
import CreateFooter from "./createFooter";
import BusinessUnitFormNavWrapper from "./BusinessUnitFormNavWrapper";
import { useBusinessUnitService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const BusinessUnitSettings: React.FC = () => {
  const businessUnitService = useBusinessUnitService();
  const urlParams = useParams<EntityIdParams>();
  const id = urlParams.id!;
  const { getMounted } = useMountedState();
  const [selectedBusinessUnitName, setSelectedBusinessUnitName] = useState<string>("");
  const [businessUnit, setBusinessUnit] = useState<WintSuperkollAPIModelTimeReporting.BusinessUnit>();

  const formRef = useRef<FormHandles>(null);
  const { navigateToPreviousLocation } = useNavigationHistory();

  React.useEffect(() => {
    businessUnitService.getBusinessUnit(id).then((result) => {
      if (getMounted()) {
        setBusinessUnit(result);
        setSelectedBusinessUnitName(result?.name ?? "");
      }
    });
  }, [id, getMounted]);

  const onSubmit = () => {
    return (formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve());
  };

  const onFormSubmitSuccess = (businessUnitId?: string) => {
    navigateToPreviousLocation({
      businessUnitId: businessUnitId,
      businessUnitName: formRef.current?.getValues && formRef.current.getValues().name,
    });
  };

  return (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`businessUnit`}
      navigation={
        <BreadCrumb
          prevItems={[
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BusinessUnit.BusinessUnits),
              href: UrlHelper.formatPath("/Reports/BusinessUnits"),
            },
            { text: selectedBusinessUnitName, href: UrlHelper.formatPath(`/BusinessUnits/${id}/`) },
          ]}
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Settings)}
          showHome
        />
      }
      hasPermissions={businessUnitService.hasEditPermissions()}
      hideSpeedDial
    >
      <WizardContextProvider>
        <FormValidity
          render={(isValid, onValidityChange) => {
            return (
              <PageLayouts.EntityCreationLayout
                className={clsx(cssExports.businessUnitSettingsWizard, cssExports.settingsWizardIcons)}
                upperLeftComponent={<SimpleEntityTitle title={selectedBusinessUnitName} />}
                upperRightComponent={<></>}
                footer={
                  <CreateFooter submitForm={onSubmit} onSubmitSuccess={onFormSubmitSuccess} isFormValid={isValid} />
                }
              >
                <BusinessUnitFormNavWrapper
                  ref={formRef}
                  selectedBusinessUnitChangeHandler={setSelectedBusinessUnitName}
                  selectedBusinessUnitName={selectedBusinessUnitName ?? ""}
                  businessUnit={businessUnit}
                  onFormValidationChange={onValidityChange}
                />
              </PageLayouts.EntityCreationLayout>
            );
          }}
        />
      </WizardContextProvider>
    </PageLayouts.EntityFullScreen>
  );
};

export default BusinessUnitSettings;
